import {
    Avatar,
    IconNames,
    MaterialIcon,
    PushButton,
    typography,
    useCountdown,
    usePreventAutoDeactivate,
    View,
    ViewContent
} from "@variocube/cube-ui";
import * as React from "react";
import {useEffect} from "react";
import {stylesheet} from "typestyle";
import {useLocalization} from "../i18n";

interface SuccessViewProps {
    title: string;
    message: string;
    icon?: IconNames;
    iconClass?: any;
    onClose: () => void;
}

export function SuccessView({title, message, icon = IconNames.check, iconClass, onClose}: SuccessViewProps) {
    const {t} = useLocalization();
    const secondsLeft = useCountdown(10, true);
    const autoCloseMessage = t("AutoCloseMessage", {secondsLeft});

    useEffect(() => {
        if (secondsLeft <= 0) {
            onClose();
        }
    }, [secondsLeft, onClose]);

    usePreventAutoDeactivate();

    return (
        <View>
            <ViewContent className={styles.viewContent}>
                <Avatar size={4} success>
                    <MaterialIcon className={iconClass} icon={icon}/>) 
                </Avatar>
                <div>
                    <h1 className={typography.title}>{title}</h1>
                    <p>{message}</p>
                    <p className={typography.muted}>{autoCloseMessage}</p>
                    <p>
                        <PushButton onClick={onClose}>
                            {t("Close")}
                        </PushButton>
                    </p>
                </div>
            </ViewContent>
        </View>
    );
}

const styles = stylesheet({
    viewContent: {
        display: "flex",
        flexFlow: "column nowrap",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center"
    },
});
